const hoverTriggers = document.getElementsByClassName('js-hover-trigger');
const videoItems = document.getElementsByClassName('c-media__video');

export function pauseAllVideos(curr) {
  [...videoItems].forEach(video => {
    const v = video;
    v.pause();
    v.currentTime = 0;
  });
  if (curr) {
    curr.classList.add('c-media--animate-clip');
    curr.addEventListener('animationend', () => {
      curr.classList.remove('c-media--animate-clip');
    });
  }
}

export function initPlayOnHover() {
  [...hoverTriggers].forEach(el => {
    el.addEventListener('mouseover', () => {
      pauseAllVideos();
      const video = el.previousElementSibling;
      video.play();
    });
    el.addEventListener('mouseleave', () => {
      pauseAllVideos(el.previousElementSibling);
    });
  });
  [...videoItems].forEach(el => {
    el.addEventListener('mouseover', () => {
      pauseAllVideos();
      el.play();
    });
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/hovers.js